<template>
  <div class="register-container">
    <div class="simple-header">
      <div class="logo" @click="goToHome">
        <img src="../assets/images/logo.png" alt="AiBZ Logo">
      </div>
    </div>
    <div class="register-box">
      <div class="title">
        <h1>AiBZ</h1>
        <p>用户注册</p>
      </div>
      <el-form ref="registerForm" :model="registerForm" :rules="registerRules" class="register-form">
        <el-form-item prop="email">
          <el-input
            v-model="registerForm.email"
            prefix-icon="el-icon-message"
            placeholder="邮箱"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="name">
          <el-input
            v-model="registerForm.name"
            prefix-icon="el-icon-user"
            placeholder="姓名"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="registerForm.password"
            prefix-icon="el-icon-lock"
            type="password"
            placeholder="密码"
            show-password
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="confirmPassword">
          <el-input
            v-model="registerForm.confirmPassword"
            prefix-icon="el-icon-lock"
            type="password"
            placeholder="确认密码"
            @keyup.enter.native="handleRegister"
            show-password
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button 
            type="primary" 
            class="register-button" 
            :loading="loading" 
            @click="handleRegister"
          >注册</el-button>
        </el-form-item>
        <div class="register-options">
          <span class="login-link" @click="goToLogin">已有账号？前往登录</span>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { post } from '../utils/fetch';

export default {
  name: 'RegisterPage',
  data() {
    const validateEmail = (rule, value, callback) => {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!value) {
        callback(new Error('请输入邮箱'));
      } else if (!emailPattern.test(value)) {
        callback(new Error('请输入有效的邮箱地址'));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入密码'));
      } else if (value.length < 6) {
        callback(new Error('密码长度至少6个字符'));
      } else {
        if (this.registerForm.confirmPassword !== '') {
          this.$refs.registerForm.validateField('confirmPassword');
        }
        callback();
      }
    };
    const validateConfirmPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请确认密码'));
      } else if (value !== this.registerForm.password) {
        callback(new Error('两次输入密码不一致'));
      } else {
        callback();
      }
    };
    return {
      registerForm: {
        email: '',
        name: '',
        password: '',
        confirmPassword: ''
      },
      registerRules: {
        email: [
          { required: true, trigger: 'blur', validator: validateEmail }
        ],
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, message: '姓名长度至少2个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, validator: validatePassword, trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, validator: validateConfirmPassword, trigger: 'blur' }
        ]
      },
      loading: false
    };
  },
  methods: {
    handleRegister() {
      this.$refs.registerForm.validate(async valid => {
        if (valid) {
          this.loading = true;
          try {
            // 提交注册请求，不包含confirmPassword字段
            const { email, name, password } = this.registerForm;
            const registerData = { email, name, password };
            
            const response = await post('/api/user/register', registerData);
            if (response.code === 200) {
              this.$message.success('注册成功，请等待管理员审核');
              this.navigateTo('/login');
            } else {
              this.$message.error(response.message || '注册失败，请重试');
            }
          } catch (error) {
            this.$message.error('注册失败：' + (error.message || '网络错误'));
          } finally {
            this.loading = false;
          }
        }
      });
    },
    
    // 安全的路由导航方法
    navigateTo(path) {
      if (this.$router.currentRoute.path !== path) {
        this.$router.push(path).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            throw err;
          }
        });
      }
    },
    
    // 前往登录页
    goToLogin() {
      this.navigateTo('/login');
    },
    
    // 前往首页
    goToHome() {
      this.navigateTo('/');
    }
  }
};
</script>

<style scoped>
.register-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: url('../assets/images/img-home-bg.png') no-repeat center center;
  background-size: cover;
  position: relative;
}

.simple-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
  width: 100%;
  padding: 0 120px;
  box-sizing: border-box;
  background-color: transparent;
  z-index: 1000;
}

.logo {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.logo img {
  height: 60px;
  width: auto;
  object-fit: contain;
  margin-right: 10px;
}

.register-box {
  width: 525px;
  padding: 60px 50px;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 35px;
  box-shadow: 0px 0 64px 0px rgba(0,23,189,0.12);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.title {
  text-align: center;
  margin-bottom: 40px;
}

.title h1 {
  color: #7e57c2;
  font-size: 36px;
  margin: 0 0 5px 0;
}

.title p {
  color: #606266;
  margin: 10px 0 0 0;
  font-size: 18px;
}

.register-form {
  margin-top: 20px;
}

.register-form .el-form-item {
  margin-bottom: 25px;
}

.register-form .el-input__inner {
  height: 50px;
  border-radius: 25px;
  padding-left: 20px;
}

.register-button {
  width: 100%;
  border-radius: 25px;
  height: 50px;
  font-size: 18px;
  background-color: #7e57c2;
  border-color: #7e57c2;
  margin-top: 10px;
}

.register-button:hover {
  background-color: #6c4aa6;
  border-color: #6c4aa6;
}

.register-options {
  margin-top: 25px;
  text-align: center;
}

.login-link {
  color: #7e57c2;
  cursor: pointer;
  font-size: 16px;
}

.login-link:hover {
  text-decoration: underline;
}

/* 调整图标位置 */
.el-input__prefix {
  left: 15px;
}
</style> 